import styled from "styled-components";

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 115px;
  width: fit-content;
  padding: 10px;
  height: 115px;
  border-radius: 10px;
  background-color: white;
  gap: 10px;

  -webkit-box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);
  -moz-box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);
  box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);

  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  ${({ $clickable }) =>
    $clickable &&
    `
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px 2px rgba(194, 194, 194, 0.4);
    }
  `}
`;

export const NumberWrapper = styled.div`
  /* height: 75%; */
  display: flex;
  align-items: center;
`;

export const NumberText = styled.p`
  font-size: 30px;
`;

export const LabelWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  /* height: 25%; */
`;

export const LabelText = styled.label`
  text-align: center;
  font-size: 12px;
  width: 98%;
`;
